import {
  ApButtonDanger,
  ApButtonGroup,
  ApButtonMain,
  ApIcon,
  ApModal,
} from '@alixpartners/ui-components';

import './SettlementsTemplateSaveConfirm.css';

interface Props {
  title: string;
  warning: string;
  onConfirm: (confirmed: boolean) => void;
}

export const SettlementsTemplateSaveConfirm = ({
  title,
  warning,
  onConfirm,
}: Props) => {
  const handleConfirmClick = () => onConfirm(true);
  const handleCancelClick = () => onConfirm(false);

  return (
    <ApModal
      className="settlements-template-save-confirm"
      isDismissible={false}
      isFluid={false}
      isOpen={true}
      zIndex={998}
      hasClosed={handleCancelClick}
      footer={() => (
        <ApButtonGroup justifyContent="space-between">
          <ApButtonDanger onClick={handleCancelClick}>Don't save</ApButtonDanger>
          <ApButtonMain onClick={handleConfirmClick}>Save changes</ApButtonMain>
        </ApButtonGroup>
      )}
    >
      <h3 className="settlements-template-save-confirm__header">{title}</h3>
      <div className="settlements-template-save-confirm__warning">
        <ApIcon iconName="outline_warning" iconColor="orange" />
        <span>{warning}</span>
      </div>
    </ApModal>
  );
};
